import Chip from '@mui/material/Chip';

import './CustomChip.scss';

const CustomChip = props => {
  return (
    <Chip
      {...props}
      className='CustomChip'
    >
      {props.children}
    </Chip>
  );
};

export default CustomChip;
